import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const PasswordInput = forwardRef(({ className, ...props }, ref) => {
  const [show, setShow] = useState(false);
  const tid = props["data-testid"] || "password";
  return (
    <div className="relative">
      <Input ref={ref} type={show ? "text" : "password"} className={cn("pr-11", className)} {...props} />
      <button type="button" onClick={() => setShow((s) => !s)} aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        className="absolute bottom-0 right-0 top-0 mt-auto flex h-11 w-11 items-center justify-center text-muted-foreground transition-colors hover:text-foreground" data-testid={`${tid}-toggle`}>
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";
